// @flow

import React from 'react';
import bemify from 'bemify-js';

import AccountMenu from 'web-ssr/app/common/components/AccountMenu';
import NotificationBell from 'web-ssr/app/common/components/NotificationsMenu/NotificationBell';
import { HeaderContext } from 'web-ssr/app/common/components/ContentHeader/HeaderProvider';
import 'web-ssr/app/common/components/ContentHeader/HeaderAccountActions.scss';

import type { Node } from 'react';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('header-account-actions');

export const HeaderBlockAccountActions = ({
  kind,
  children,
}: {
  kind?: KindType,
  children: Node,
}) => <div className={bem(kind)}>{children}</div>;

type Props = {
  kind?: KindType,
};

// TODO(neilff): These are temporary styles for the header to make the
// notification bell appear as though it is clickable
const mockClickableStyles = {
  cursor: 'pointer',
  display: 'flex',
  height: '49px',
  width: '49px',
  alignItems: 'center',
  justifyContent: 'center',
};

const HeaderAccountActions = ({ kind }: Props) => (
  <HeaderContext.Consumer>
    {context => {
      return (
        <HeaderBlockAccountActions kind={kind}>
          <AccountMenu
            accountId={context.accountId}
            className={bem('__account-menu-container')}
            email={context.email}
            imageUrl={context.imageUrl}
            isDeveloper={context.isDeveloper}
          />

          {/*
          TODO(neilff): This represents a static, non-interactive version of the
          notification menu. The interactive dropdown will be implemented in a later PR
          */}
          <div style={mockClickableStyles}>
            <NotificationBell
              hasImportant={false}
              hasUndelivered={false}
              onBellRingFinished={() => {}}
              unreadCount={0}
            />
          </div>
        </HeaderBlockAccountActions>
      );
    }}
  </HeaderContext.Consumer>
);

export default HeaderAccountActions;
